import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LOGO = 'https://public.readdy.ai/ai/img_res/1263c92f-fd0b-47c8-8fec-161a92cdc272.png';

export default function SiteFooter() {
  const { t } = useTranslation();

  const links = [
    { label: t('nav.residence'), to: '/' },
    { label: t('nav.gallery'), to: '/galerie' },
    { label: t('nav.highlights'), to: '/highlights' },
    { label: t('nav.location'), to: '/lage' },
    { label: t('nav.contact'), to: '/kontakt' },
  ];

  return (
    <footer className="bg-[#F0EDE8] border-t border-[#E5DDD3]">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          {/* Logo + tagline */}
          <div>
            <Link to="/">
              <img src={LOGO} alt="Obsidian Properties" className="h-10 w-auto object-contain mb-5" />
            </Link>
            <p className="font-sans text-[12px] text-[#6B6460] leading-relaxed font-light max-w-xs">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#B59A6A] mb-6">
              {t('footer.navigation')}
            </p>
            <div className="flex flex-col gap-3">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="font-sans text-[12px] text-[#6B6460] hover:text-[#1C1C1C] transition-colors duration-300"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact quick */}
          <div>
            <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#B59A6A] mb-6">
              {t('footer.contact')}
            </p>
            <div className="flex flex-col gap-3">
              <a href="tel:+41449998877" className="flex items-center gap-2 font-sans text-[12px] text-[#6B6460] hover:text-[#1C1C1C] transition-colors">
                <i className="ri-phone-line text-[#B59A6A] text-xs" />
                +41 44 999 88 77
              </a>
              <a href="mailto:a.hartmann@obsidianproperties.ch" className="flex items-center gap-2 font-sans text-[12px] text-[#6B6460] hover:text-[#1C1C1C] transition-colors">
                <i className="ri-mail-line text-[#B59A6A] text-xs" />
                a.hartmann@obsidianproperties.ch
              </a>
              <p className="flex items-center gap-2 font-sans text-[12px] text-[#6B6460]">
                <i className="ri-map-pin-line text-[#B59A6A] text-xs" />
                Bahnhofstrasse 12, 8001 Zürich
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-[#E5DDD3] flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-[10px] tracking-widest uppercase text-[#BFBAB5]">
            {t('footer.copyright')}
          </p>
          <p className="font-sans text-[10px] text-[#BFBAB5]">
            {t('footer.studio')}{' '}
            <span className="text-[#B59A6A]">Obsidian Properties</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
